import { render, staticRenderFns } from "./ApprovedAnsBtn.vue?vue&type=template&id=d93854ac&scoped=true"
import script from "./ApprovedAnsBtn.vue?vue&type=script&lang=js"
export * from "./ApprovedAnsBtn.vue?vue&type=script&lang=js"
import style0 from "./ApprovedAnsBtn.vue?vue&type=style&index=0&id=d93854ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d93854ac",
  null
  
)

export default component.exports